export default function GetCurrentCognitoDetailsMethod() {
  console.log(window.location.hostname);

  switch (window.location.hostname) {
    case "www.uat.bms.rcshealth.io":
    case "uat.bms.rcshealth.io":
      // case "localhost":
      // return {
      //   userPoolId: "us-east-1_4i92EXlFL",
      //   userPoolClientId: "6u24hkaouicpi7ie8pdcqjlm8a",
      //   signUpVerificationMethod: "code",
      //   loginWith: {
      //     email: true,
      //   },
      // };
       return {
        userPoolId: "us-east-1_vuOEUg6Wk",
        userPoolClientId: "7mp82m26v0o3lee1ue9im2tqeg",
        signUpVerificationMethod: "code",
        loginWith: {
          email: true,
        },
        identityPoolId:'us-east-1:8f9d3a85-4d7e-4202-8fc8-3d653f6525e8',
      };


    case "www.dev.bms.rcshealth.io":
    case "dev.bms.rcshealth.io":
    case "localhost":
      // return {
      //   userPoolId: "us-east-1_gHwxsn9o4",
      //   userPoolClientId: "2fnics2l6qdh49deume9hjcntq",
      //   signUpVerificationMethod: "code",
      //   loginWith: {
      //     email: true,
      //   },
      // };
       return {
        userPoolId: "us-east-1_Yafjle7Ih",
        userPoolClientId: "4duabcfofpo67u0d59j3hgbsqk",
        signUpVerificationMethod: "code",
        loginWith: {
          email: true,
        },
        identityPoolId:'us-east-1:979d963a-9306-46f4-bff0-e92c6b2840b4'
      };
      case "www.bms.rcshealth.io":
      case "bms.rcshealth.io":
      // case "localhost":
      return {
        userPoolId: "us-east-1_Aa4FEjqC9",
        userPoolClientId: "2u7embgkc884hnmo29hp8ash49",
        signUpVerificationMethod: "code",
        loginWith: {
          email: true,
        },
        identityPoolId:'us-east-1:b350ce2b-397c-43c1-b864-0c29c43cb90a',
      };
    default:
      return {
        userPoolId: "us-east-1_ANsP6lGfr",
        userPoolClientId: "cgeq354gfocbv1acd58ll8pcr",
        signUpVerificationMethod: "code",
        loginWith: {
          email: true,
        },
      };
  }
}
